import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IWorkspace } from '../../models/IWorkspace';
// import { DataUtils } from './data-utils';
import { DataUtils } from '../../shared/utilities/data-utils';


@Injectable()
export class WorkspaceService {
  private baseUrl = environment.baseUrl;

  public static mapWorkspaceDates(workspace: IWorkspace): IWorkspace {
    DataUtils.replaceDatePropertyIfPresent(workspace, 'startDate');
    DataUtils.replaceDatePropertyIfPresent(workspace, 'endDate');
    DataUtils.replaceDatePropertyIfPresent(workspace, 'lastShareDate');
    return workspace;
  }

  constructor(private http: HttpClient) { }

  getWorkspaces(strategyId: number, institutionId: number): Observable<IWorkspace[]> {
    return this.http.get(`${this.baseUrl}/strategies/${strategyId}/institutions/${institutionId}/workspaces`)
      .pipe(map((it: IWorkspace[]) => it.map(WorkspaceService.mapWorkspaceDates)));
  }
}
